<template>
	<button
		:type="submit ? 'submit' : 'button'"
		:class="[
			'btn',
			`btn--${color}`,
			`btn--${size}`,
			{ full: full },
			{ loading: loading },
			{ disabled: disabled }
		]"
	>
		<slot v-if="!loading"></slot>
		<Loading v-if="loading" />
	</button>
</template>

<script>
import Loading from './Loading'

export default {
	name: 'Button',
	components: {
		Loading
	},
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		color: {
			type: String,
			default: ''
		},
		size: {
			type: String,
			default: ''
		},
		full: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			default: false
		},
		submit: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style scoped lang="scss">
.btn {
	padding: 0 15px 0 15px;
	height: 50px;
	border: none;
	background-color: #59bdf6;
	color: $colorWhite;
	cursor: pointer;
	box-shadow: 0px 5px 10px -5px rgba(8, 86, 111, 0.2);
	text-shadow: 1px 1px rgba(0, 0, 0, 0.1);
	font-size: 16px;
	font-weight: 500;
	min-width: 110px;
	white-space: nowrap;

	@include for-tablet-portrait-up {
		padding: 0 30px 0 30px;
	}

	&.loading {
		pointer-events: none;
	}

	&.disabled {
		//background-color: #d4f1fe;
		pointer-events: none;
		background-color: #d5d8df;
		cursor: auto;
		box-shadow: none;
	}

	&--disable {
		background-color: #59bdf6;
	}

	&:hover {
		background-color: #4ba1d3;
		&.disabled {
			background-color: #d5d8df;
			//background-color: #d4f1fe;
		}
	}

	&.full {
		width: 100%;
	}
	&--less-padding {
		padding: 0 20px 0 20px;
	}
	&--button-like-behavior {
		transition: 0.2s all;

		// not needed but it gives a nice smoth shadow
		box-shadow: 0 1px 2px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.07),
			0 4px 8px rgba(0, 0, 0, 0.07), 0 8px 16px rgba(0, 0, 0, 0.07),
			0 16px 32px rgba(0, 0, 0, 0.07), 0 32px 64px rgba(0, 0, 0, 0.07);

		&:active {
			transform: scale(0.98);
		}
	}

	&--xsmall {
		height: 30px;
		min-width: auto;
		font-size: 13px;
		padding: 0 10px;
	}
	&--small {
		height: 40px;
		min-width: auto;
		font-size: 16px;
		@include for-tablet-portrait-up {
			font-size: 13px;
		}
	}

	&--large {
		height: 70px;
		min-width: 120px;
	}
	&--square {
		height: auto;
		width: auto;
		padding: 10px;
		min-width: 0;
		font-size: 0;
		line-height: 1;
	}

	&--red {
		background-color: $colorRed;
		svg {
			fill: $colorWhite;
		}
		&.disabled {
			background-color: #d5d8df;
			&:hover {
				background-color: #d5d8df;
			}
		}
		&:hover {
			background-color: $colorDarkerRed;
		}
	}
	&--cancel {
		min-width: 50px;
		padding: 0 20px;
		background-color: $colorDarkRed;
		&.disabled {
			background-color: $colorRed;
			&:hover {
				background-color: $colorRed;
			}
		}
		&:hover {
			background-color: $colorDarkerRed;
		}
	}

	&--dark {
		background-color: RGBA(116, 128, 151, 1);
		&.disabled {
			background-color: #d5d8df;
			&:hover {
				background-color: #d5d8df;
			}
		}

		&:hover {
			background-color: RGBA(116, 108, 131, 1);
		}
	}
	&--primary4 {
		background-color: $colorPrimary4;
		&.disabled {
			background-color: #d5d8df;
			&:hover {
				background-color: #d5d8df;
			}
		}

		&:hover {
			background-color: $colorPrimary4;
		}
	}
	&--primary6 {
		background-color: $colorPrimary6;
		&.disabled {
			background-color: #d5d8df;
			&:hover {
				background-color: #d5d8df;
			}
		}

		&:hover {
			background-color: $colorPrimary4;
		}
	}

	&--dark-bg {
		&:hover {
			background-color: $colorSecondary8;
		}
	}
}
</style>
